var _path, _circle, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStickyNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72596 19.4568C11.3337 19.6108 12.6558 19.2002 13.7346 20.0213C14.8135 20.8525 19.8692 23.3053 19.1183 21.1091C18.3673 18.9129 18.5577 18.0611 19.1183 17.6403C21.974 15.4852 23 13.9458 23 10.7335C23 5.63299 18.2404 2 12.1058 2C5.97115 2 1 6.13586 1 11.2364C1 16.337 4.99808 18.995 9.72596 19.4568Z",
    fill: "#307FE2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.923,
    cy: 7.5485,
    r: 1.17692,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.942 11.416L11.9325 14.599Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.942 11.416L11.9325 14.599",
    stroke: "white",
    strokeWidth: 2.35385,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNote);
export default __webpack_public_path__ + "static/media/sticky-note.2456f542b2eeb3573e8e78ea9d7e5a3e.svg";
export { ForwardRef as ReactComponent };